import { ApplicationState } from '@app/store'
import {
  IGlobalRolesState,
  IGlobalTeamsState,
  selectRolesList,
  selectTeams,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import MembershipEditor from '../components/MembershipEditor'

export default connect(
  (state: ApplicationState) =>
    createStructuredSelector<
      ApplicationState,
      IGlobalRolesState & IGlobalTeamsState
    >({
      roles: selectRolesList(),
      teams: selectTeams(),
    }),
  {},
)(MembershipEditor)
